import DownloadAppModal from 'components/Profile/modals/DownloadAppModal';
import { useUserDetails } from 'lib/queries/user';
import { useEffect, useState } from 'react';

interface PersonalInfoCheckProps {
    onComplete?: () => void;
}

const PersonalInfoCheck = ({ onComplete }: PersonalInfoCheckProps) => {
    const [settled, setSettled] = useState(false);
    const { data: userDetails, refetch: fetchUserDetails } = useUserDetails();
    const shouldShowModal = !settled && userDetails?.hasMissingInfo;

    useEffect(() => {
        if (userDetails && !userDetails.hasMissingInfo) {
            setSettled(true);
        }
    }, [userDetails?.hasMissingInfo]);

    useEffect(() => {
        if (settled) {
            onComplete?.();
        }
    }, [settled]);

    useEffect(() => {
        fetchUserDetails();
    }, []);

    return shouldShowModal ? (
        <DownloadAppModal onClose={() => {}} mandatory={true} />
    ) : null;
};

export default PersonalInfoCheck;
